import type { Ref } from 'vue';
import { HttpMethods, RequestPerformer } from '@/api/api-requests-factory';
import UpdateAvailableCurrencyListRequest from '@/api/currency/update-currency-list-request';

export class CurrencyApiResources {
  constructor(
    private readonly requestPerformer: RequestPerformer,
    private readonly multibrandApiHost: Ref<string>,
  ) { }

  public get updateAvailableCurrencyListRequest(): UpdateAvailableCurrencyListRequest {
    return new UpdateAvailableCurrencyListRequest(
      this.requestPerformer,
      `${this.multibrandApiHost.value}/api/v1.0/front/currency`,
      HttpMethods.PATCH,
    );
  }
}
